import { Pipe, PipeTransform } from '@angular/core';

export interface PatientContactPerson {
  contactPersonName: string;
  contactPersonEmail: string;
  contactPersonPhone: string;
}

@Pipe({
  name: 'contactPerson'
})
export class ContactPersonPipe implements PipeTransform {

  transform(value: PatientContactPerson): any {
    return ((value.contactPersonName ? value.contactPersonName : '') +
      (value.contactPersonEmail ? ' - ' + value.contactPersonEmail : '') +
      (value.contactPersonPhone ? ' - ' + value.contactPersonPhone : ''));
  }

}
